import React, { useState } from 'react';
import '../Profile.css';

const PersonalDataBlock = ({ capture, data }) => {

    let formattedDate = "";
    if (!isNaN(Date.parse(data))) {
        const date = new Date(data);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        formattedDate = `${day}.${month}.${year}`;
    }

    return (
        <div className='personalDataBlock__container'>
            <div className='personalDataBlock__capture'>{capture}</div>
            <div className='personalDataBlock__info'>{formattedDate !== '' ? formattedDate : data}</div>
        </div>
    )
}
export default PersonalDataBlock
